"use client";
import { GuidesHero } from "./guides-hero";
import GuidesSections from "./sections";
import { HeroSectionType } from "../features/hero";

export function GuidesPageContent({ data }: { data: HeroSectionType }) {
  return (
    <div>
      <GuidesHero data={data} />
      <GuidesSections />
    </div>
  );
}
